import logo from "../../../assets/images/logo-cozimax.png";

export const Header = ({ navigate }) => {
    return (
        <header style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px 0",
            backgroundColor: "#fff",
            borderBottom: "1px solid #ddd",
            top: 0,
            zIndex: 1000,
        }}>
            <img
                src={logo}
                alt="Logo"
                className="logo"
                style={{ cursor: "pointer", height: "40px" }}
                onClick={() => navigate("/")}
            />
        </header>

    )
}

